export const error = $state<{ error: string | null }>({ error: null });
